import React from 'react';
import HelpText from '../quiz/HelpText';

export default function SideBySide({ components, style, colstyles, enableTextToAudio, ...props }) {

    return (
        <div style={{ ...styles.container, ...style }} {...props}>
            {components && components.map((Component, index) => (

                <div style={styles.item} key={index}>
                    <Component />
                </div>
            ))}
            {props.helpText && <HelpText data={props.helpText} />}
        </div>
    );
}

const styles = {
    container: {
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '20px',
        position: 'relative',
        flexWrap: 'wrap',
    },
    item: {
        flex: '1 1 0',
        minWidth: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
}